import { z } from 'zod'

export const UnitRate = z.object({
  metric: z.string(),
  price_cents: z.number(),
  display_unit: z.string()
})
export type UnitRate = z.infer<typeof UnitRate>

export const ServiceRates = z.object({
  service: z.string(),
  display_name: z.string(),
  currency: z.string(),
  base_fee_cents: z.number(),
  base_fee_interval: z.string(),
  unit_rates: z.array(UnitRate)
})
export type ServiceRates = z.infer<typeof ServiceRates>

export const PricingRatesResponse = z.object({
  services: z.array(ServiceRates)
})
export type PricingRatesResponse = z.infer<typeof PricingRatesResponse>
